var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{class:[
    'settings-section-title i-text-heading-4 i-text-neutral-120',
    { active: _vm.$route.hash === `#${_vm.id}` },
  ],attrs:{"id":_vm.id}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }